<template>
<div class="content">
        <div class="row">
          <div class="col">
            <app-studenttable></app-studenttable> <div > 
        <div class="card text-dark bg-light mb-3" style="" >
        <div class="card-header text-danger"><h5>ÖĞRENCİ BİLGİLERİ</h5></div>
        <div class="card-body" >
            <div class="row">
                <div class="col-9">
                    <h5 class="card-title"> {{getStudents[getSelectedStudent].adi}}</h5>
                </div>
                <div @click="goToBack" class="col-2"><button class="btn btn-success btn-round">LİSTEYE DÖN</button></div>
            </div>
            <hr>
            <h5 class="card-title text-danger">GENEL BİLGİLER</h5>
            <hr>
            <div class="container">
            <div class="row">
                <div class="col">
                    <p class="card-text">TC.KİMLİK : {{getStudents[getSelectedStudent].tc}}</p>
                </div>
                <div class="col">
                    <p class="card-text">CİNSİYET : {{getStudents[getSelectedStudent].cinsiyet}}</p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">DOĞUM TARİHİ : {{getStudents[getSelectedStudent].dogumTarihi}}</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">FAKÜLTE : {{getStudents[getSelectedStudent].fakulte}}</p>
                </div>
                <div class="col">
                    <p class="card-text">BÖLÜM : {{getStudents[getSelectedStudent].bolum}}</p>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">OKUL NO : {{getStudents[getSelectedStudent].okulNo}}</p>
                </div>
            </div>
            </div>
            <hr>
            <h5 class="card-title text-danger">İLETİŞİM BİLGİLERİ</h5>   
            <hr>        
            <div class="row">
                <div class="col">
                    <p class="card-text">ADRES : {{getStudents[getSelectedStudent].adres}}</p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">TELEFON : {{getStudents[getSelectedStudent].telefon}}</p>
                </div>
                <div class="col">
                    <p class="card-text">E POSTA : {{getStudents[getSelectedStudent].eposta}}</p>
                </div>
            </div>
            <hr>
            <h5 class="card-title text-danger">OKUL DURUMU</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">MEZUN OLDUĞU OKUL : {{getStudents[getSelectedStudent].mezunOkul}}</p>
                </div>
                <div class="col">
                    <p class="card-text">NOT ORTALAMASI : {{getStudents[getSelectedStudent].notOrt}}</p>
                </div>
            </div>
            <hr>
            <h5 class="card-title text-danger">STAJ TECRÜBELERİ</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">KURUM ADI : {{getStudents[getSelectedStudent].kurumAdi}}</p>
                </div>
                <div class="col">
                    <p class="card-text">DEPARTMAN : {{getStudents[getSelectedStudent].departman}}</p>
                </div>
            </div>
             <hr>
            <h5 class="card-title text-danger">PROJE</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">ADI : {{getStudents[getSelectedStudent].projeAdi}}</p>
                </div>
                <div class="col">
                    <p class="card-text">GÖREVİ : {{getStudents[getSelectedStudent].projeGorev}}</p>
                </div>
            </div>
             <hr>
            <h5 class="card-title text-danger">BECERİLER VE NİTELİKLER</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">GÜÇLÜ YÖNLER : {{getStudents[getSelectedStudent].gucluYonler}}</p>
                </div>
                <div class="col">
                    <p class="card-text">ÖZEL İLGİ ALANI : {{getStudents[getSelectedStudent].ilgiAlani}}</p>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col">
                    <p class="card-text">KAZANDIĞI ÖDÜL : {{getStudents[getSelectedStudent].odul}}</p>
                </div>
                <div class="col">
                    <p class="card-text">SERTİFİKA : {{getStudents[getSelectedStudent].sertifika}}</p>
                </div>
            </div>
            <hr>
            <h5 class="card-title text-danger">DANIŞMANLIK NOTU</h5>
            <hr>
            <div class="row">
                <div class="col">
                    <p class="card-text">{{getStudents[getSelectedStudent].danismanlik}}</p>
                </div>
            </div>
            <br>
            <div class="row ">
               <div class="update ml-auto mr-auto">
                    <button class="btn btn-danger btn-round  ">YAZDIR</button>
               </div>  
                
            </div>
            
        </div>
</div>
    </div>
          </div>
        </div>
      </div>

   
</template>
<script>
import { mapGetters} from "vuex";

export default {
    computed : {
      ...mapGetters(["getStudents","getSelectedStudent"])
    },
    data (){
      return {
         
      }
    }, 
    methods :{
        goToBack(){
        this.buttonClicked = true
        this.$router.push("/student")
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/student/StudentInfo.vue